import { Link } from "react-router-dom";
import { PRODUCTS, SITE } from "../lib/site";
import { ArrowUpRight } from "lucide-react";

function platformLabel(p) {
  switch (p) {
    case "unlockt": return "Unlockt.me";
    case "clips4sale": return "Clips4sale";
    case "iwantclips": return "iWantClips";
    default: return "Shop";
  }
}
function platformLink(p) {
  // Product-level url overrides platform storefront if present.
  if (p && typeof p === "object" && p.url && p.url.trim()) return p.url;
  const platform = typeof p === "string" ? p : p?.platform;
  return SITE.external[platform] || SITE.external.unlockt;
}

export default function FeaturedProducts({ limit = 4, title = true }) {
  const items = PRODUCTS.slice(0, limit);
  return (
    <section className="py-24 md:py-32 max-w-7xl mx-auto px-6 md:px-10 lg:px-16" data-testid="featured-products">
      {title && (
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <div className="eyebrow mb-3">The Library</div>
            <h2 className="font-serif text-4xl md:text-5xl text-cream leading-tight max-w-xl">
              Selected works for <em className="text-gold">private hours</em>.
            </h2>
          </div>
          <Link to="/shop" className="link-gold text-xs uppercase tracking-[0.22em] inline-flex items-center gap-2" data-testid="featured-shop-link">
            Enter the full shop <ArrowUpRight size={14} />
          </Link>
        </div>
      )}

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-[#c9a04b]/15">
        {items.map((p, i) => (
          <a
            key={p.id}
            href={platformLink(p)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`product-card-${p.id}`}
            className="group bg-charcoal hover:bg-charcoalMuted transition-colors p-6 flex flex-col"
          >
            <div className="aspect-[4/5] overflow-hidden mb-6 border border-[#c9a04b]/15">
              <img src={p.cover} alt={p.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
            </div>
            <div className="eyebrow mb-2">{p.kind}</div>
            <h3 className="font-serif text-xl text-cream mb-3 leading-snug">{p.title}</h3>
            <div className="flex items-center justify-between mt-auto pt-4 border-t border-[#c9a04b]/15">
              <span className="text-gold text-sm">{p.price}</span>
              <span className="text-[10px] uppercase tracking-[0.22em] text-cream/50 inline-flex items-center gap-1">
                {platformLabel(p.platform)} <ArrowUpRight size={11} />
              </span>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}
